import { render } from "./MaterialsPrinters.vue?vue&type=template&id=e3c00744"
import script from "./MaterialsPrinters.vue?vue&type=script&lang=js"
export * from "./MaterialsPrinters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__